import React from 'react';
import { programs } from '../mock';
import { Dumbbell, Music, Sparkles, Heart, ArrowRight } from 'lucide-react';

const iconMap = {
  Dumbbell: Dumbbell,
  Music: Music,
  Sparkles: Sparkles,
  Heart: Heart
};

const ProgramsSection = () => {
  return (
    <section id="programs" className="py-20 bg-black scroll-mt-24">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight">
            Our Programs
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Choose from our diverse range of fitness programs designed to help you achieve your goals
          </p>
        </div>

        {/* Programs Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {programs.map((program) => {
            const IconComponent = iconMap[program.icon];
            return (
              <div
                key={program.id}
                className="program-card group relative overflow-hidden rounded-2xl bg-gray-900 hover:transform hover:scale-105 transition-all duration-500 cursor-pointer shadow-xl hover:shadow-2xl hover:shadow-brand-primary/20"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={program.image}
                    alt={program.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent"></div>
                  
                  {/* Icon */}
                  <div className="absolute top-4 right-4 w-12 h-12 bg-brand-primary rounded-full flex items-center justify-center group-hover:rotate-12 transition-transform duration-300">
                    {IconComponent && <IconComponent className="text-black" size={24} />}
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-brand-primary transition-colors duration-300">
                    {program.title}
                  </h3>
                  <p className="text-gray-400 mb-4 leading-relaxed">
                    {program.description}
                  </p>
                  <button className="text-brand-primary font-semibold flex items-center gap-2 group-hover:gap-4 transition-all duration-300">
                    Learn More
                    <ArrowRight size={18} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProgramsSection;


